export enum ExamsAndTestNavigation {
    Dna = "dna-tests",
    Blood = "blood-tests",
    Other = "other-tests",
}